import axios from 'axios';

const seminerCreate = async (data) => {
  let response;
  var config = {
    method: 'post',
    url: process.env.REACT_APP_API_URL + '/api/v1/seminer/create',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: 'bearer ' + localStorage.getItem('accessToken'),
    },
    data: data,
  };
  await axios(config)
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      console.log(err);
      response = err;
    });
  return response;
};

const seminerGetbyId = async (id) => {
  let response;
  var config = {
    method: 'get',
    url: process.env.REACT_APP_API_URL + '/api/v1/seminer/get/' + id,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: 'bearer ' + localStorage.getItem('accessToken'),
    },
  };
  await axios(config)
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      console.log(err);
      response = err;
    });
  return response;
};

const seminerGetAll = async (tip, data = null) => {
  let response;
  var config = {
    method: 'post',
    url: process.env.REACT_APP_API_URL + '/api/v1/seminer/' + tip,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: 'bearer ' + localStorage.getItem('accessToken'),
    },
    data: data,
  };
  await axios(config)
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      console.log(err);
      response = err;
    });
  return response;
};

const seminerUpdate = async (id, data) => {
  let response;
  var config = {
    method: 'put',
    url: process.env.REACT_APP_API_URL + '/api/v1/seminer/update/' + id,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: 'bearer ' + localStorage.getItem('accessToken'),
    },
    data: data,
  };
  await axios(config)
    .then((res) => {
      response = res;
    })
    .catch((err) => {
      console.log(err);
      response = err;
    });
  return response;
};

export { seminerCreate, seminerGetbyId, seminerGetAll, seminerUpdate };
